import { PersonRelationType } from '@dealstack/shared/lib/generated';

export enum EDIT_RELATED_PERSON_FORM_FIELDS {
	relation_type = 'relation_type',
	relation_id = 'relation_id',
	create_legal_rep = 'create_legal_rep',
	custom_relation_type = 'custom_relation_type',
}

export interface EditRelatedPersonFormValues {
	[EDIT_RELATED_PERSON_FORM_FIELDS.relation_type]: PersonRelationType;
	[EDIT_RELATED_PERSON_FORM_FIELDS.relation_id]: string;
	[EDIT_RELATED_PERSON_FORM_FIELDS.create_legal_rep]?: boolean;
	/** Free-text role; only used when relation_type is OTHER. */
	[EDIT_RELATED_PERSON_FORM_FIELDS.custom_relation_type]?: string;
}
